import Vue from "vue";
import AudioPlaylistPlayer from "./audio-playlist-player";

document.addEventListener("DOMContentLoaded", () => {
  const mount = document.querySelector('[data-audio-playlist-player]');

  if (mount) {
    new Vue({
      el: mount,
      components: { AudioPlaylistPlayer },
      data: {
        audioSource: mount.getAttribute('data-audio-src'),
        firstTourStopId: parseInt(mount.getAttribute('data-first-tour-stop-id')),
        lastTourStopId: parseInt(mount.getAttribute('data-last-tour-stop-id')),
        nextStopId: parseInt(mount.getAttribute('data-next-stop-id')),
        previousStopId: parseInt(mount.getAttribute('data-previous-stop-id')),
        totalTourStopCount: parseInt(mount.getAttribute('data-total-tour-stop-count')),
        tourId: parseInt(mount.getAttribute('data-tour-id')),
        tourStopId: parseInt(mount.getAttribute('data-tour-stop-id')),
      },
      template:
        `
          <AudioPlaylistPlayer
            :audioSource=audioSource
            :firstTourStopId=firstTourStopId
            :lastTourStopId=lastTourStopId
            :nextStopId=nextStopId
            :previousStopId=previousStopId
            :totalTourStopCount=totalTourStopCount
            :tourId=tourId
            :tourStopId=tourStopId
          />
        `
    });
  }
});
